import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../../configs';
import makeRequest from '../../../../utils/makeRequest';
import { OK } from '../../../../configs/serverStatusCodes';
import { editBlackWhitesFailed, editBlackWhitesSuccessful } from '../../actions';
import { resolveActionPromise } from '../../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../../utils/rejectActionPromise';
import processError from '../../../../utils/processError';

export default function* editBlackWhites(action) {
  try {
    const pool = action.payload;
    const url = `${BACKEND_URL}/proxy/black-white/v1/blackwhites/${pool?.id}`;
    const dataResponse = yield makeRequest(url, pool, action, 'PATCH', true);
    if (dataResponse.status === OK) {
      yield put(editBlackWhitesSuccessful([]));
      yield call(resolveActionPromise(action, {}));
    } else {
      const data = yield dataResponse.json();
      yield put(editBlackWhitesFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(editBlackWhitesFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
